module.exports = __webpack_public_path__ + "img/ve.00301328.svg";